export type PaymentTermOption = { text: string; value: number };

export const PAYMENT_TERM_OPTIONS: PaymentTermOption[] = [
  { text: "Same-day payment", value: 1 },
  { text: "Within 5 days", value: 5 },
  { text: "Within 2 weeks", value: 14 },
  { text: "Within 1 month", value: 30 }
];

export function formatPaymentTerms(
  value: number | string | null | undefined
): string {
  const match = PAYMENT_TERM_OPTIONS.find(
    option => option.value === Number(value)
  );
  return match
    ? match.text
    : value === null || value === undefined
    ? ""
    : `Unknown (${value})`;
}

export const MANUAL_BOOKING_PAYMENT_METHOD_OPTIONS = [
  { text: "Pay Now", value: 1 },
  { text: "Cheque / Check", value: 2 },
  { text: "PayPal / e-Transfer", value: 3 },
  { text: "Direct Deposit", value: 4 }
];
